import { render, staticRenderFns } from "./courseVideo.vue?vue&type=template&id=5c4f3b9e&scoped=true"
import script from "./courseVideo.vue?vue&type=script&lang=js"
export * from "./courseVideo.vue?vue&type=script&lang=js"
import style0 from "./courseVideo.vue?vue&type=style&index=0&id=5c4f3b9e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4f3b9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c4f3b9e')) {
      api.createRecord('5c4f3b9e', component.options)
    } else {
      api.reload('5c4f3b9e', component.options)
    }
    module.hot.accept("./courseVideo.vue?vue&type=template&id=5c4f3b9e&scoped=true", function () {
      api.rerender('5c4f3b9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/course/courseVideo.vue"
export default component.exports